<template>
  <section class="page-content message-center">
    <div class="page-title">
      <span>{{ $lang.messages.messageCenter.toUpperCase() }}</span>
    </div>

    <div class="box-shadow-gray">
      <div class="messages-wrapper" :style="{height: detectMobile() ? isIOS(94): ''}">
        <!-- Contacts component -->
        <contacts
            class="names-section"
            ref="contacts"
            :key="rerenderContacts"
            :currentConversation="currentConversation"
            :detectMobile="detectMobile()"
            @loadConversation="loadConversation"
            @createConversation="createConversation">
        </contacts>
        <!-- Contacts component# -->

        <!-- Conversation component -->
        <conversation
            class="chat-section"
            ref="conversation"
            v-if="renderConversation"
            :key="rerenderConversation"
            :detectMobile="detectMobile()"
            :currentConversation="currentConversation"
            @sendMessage="sendMessage"
            @loadSubsequentMessages="loadSubsequentMessages"
            @loadAllUnreadMessages="loadAllUnreadMessages">
        </conversation>
        <div class="chat-section no-background" v-if="!renderConversation"></div>
        <!-- Conversation component#-->

        <!-- Schedule component -->
        <!--  <schedule class="schedule-section" v-if="renderConversation && isScheduleVisible"></schedule>-->
        <div class="schedule-section no-background" v-if="renderConversation && isScheduleVisible"></div>
        <!-- Schedule component# -->
      </div>
    </div>

  </section>
</template>

<script>

  import Contacts from "@/components/appLayout/views/messageCenter/Contacts";
  import Conversation from '@/components/appLayout/views/messageCenter/Conversation';
  import Schedule from '@/components/appLayout/views/messageCenter/Schedule'
  import { mapGetters, mapMutations, mapActions } from "vuex";
  import { WS_MESSAGES_SUBSCRIBE, WS_INITIAL_MESSAGES_SEND, WS_CREATE_CONVERSATION_SEND, WS_SEND_MESSAGE_SEND, WS_SUBSEQUENT_SEND, WS_ALL_UNREAD_SEND } from '@/constants/ApiConstants';
  import { isIOS } from '@/mixins/isIOS';
  import { SET_CONVERSATIONS_LIST } from "@/store/mutation.types";
  import { SET_SUBSCRIBED_CONVERSATIONS_LIST } from "@/store/action.types";

  export default {
    name: "messageCenter",
    components: {
      contacts: Contacts,
      conversation: Conversation,
      schedule: Schedule
    },
    mixins: [
      isIOS
    ],
    data() {
      return {
        rerenderContacts: 0,
        rerenderConversation: 0,
        renderConversation: false,
        isScheduleVisible: window.innerWidth > 990,
        conversationGuidParam: this.$route.params.guid,
        messages: {
          listOfReadMessages: [],
          listOfUnreadMessages: []
        },
        currentConversation: {},
        subscribed: false,
        conversationsList: []
      };
    },
    computed: {
      ...mapGetters(["coparentGuid", "getScrollDirection"]),
      subscribedConversationsList() {
        return this.$store.getters.getSubscribedConversationsList
      }
    },
    watch: {
      conversationsList() {
        if (this.conversationsList.length > 0) {
          this.trySubscribeWebscoket();
          this.loadCurrentConversation();
        }
      },
    },
    mounted() {
      this.conversationsList = this.$store.getters.getConversationsList;
      this.$root.$on('conversations', this.conversationsUpdated);
      this.$root.$on('loadConversation', this.loadConversation);
      this.trySubscribeWebscoket();
      this.loadCurrentConversation();
      window.addEventListener('resize', this.handleShowHideSchedule)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleShowHideSchedule)
    },
    methods: {
      ...mapMutations({
        conversationsListMutation: SET_CONVERSATIONS_LIST
      }),
      ...mapActions({
        setSubscribedConversationsListAction: SET_SUBSCRIBED_CONVERSATIONS_LIST
      }),
      conversationsUpdated(conversations) {
        this.conversationsList = conversations;
        if (this.conversationsList.length > 0) {
          this.trySubscribeWebscoket();
        }
      },
      handleShowHideSchedule() {
        this.isScheduleVisible = window.innerWidth > 990
      },
      trySubscribeWebscoket() {
        let itemsProcessed = 0;
        this.conversationsList.forEach(person => {
          if (this.subscribedConversationsList) {
            let item = this.subscribedConversationsList.find(item => item.conversationGuid === person.conversationGuid);
            if (item) {
              if (person.conversationGuid !== null && !item.subscribed) {
                this.subscribeWebsocket(person);
                this.makeConversationSubscribed(person);
                itemsProcessed++;
                if(itemsProcessed === this.conversationsList.length) {
                  this.loadInitialMessages();
                }
              }
            }
          }
        });
      },
      // Subscribing to channel where we get messages
      // Response can be initial list of messages with read and unread lists
      // Response can be list of messages when user scrolls UP or DOWN
      // Response can also be one new message
      subscribeWebsocket(person) {
        if (this.$parent.stompClient && this.$parent.stompClient.connected) {
          this.$parent.stompClient.subscribe(WS_MESSAGES_SUBSCRIBE.replace(':coparentGuid', this.coparentGuid).replace(':participantGuid', person.participantGuid), tick => {
            let data = JSON.parse(tick.body);
            // Sends the initial 15 messages
            if (data.listOfReadMessages && data.listOfUnreadMessages) {
              this.messages = {
                listOfReadMessages: [...data.listOfReadMessages.reverse()],
                listOfUnreadMessages: [...data.listOfUnreadMessages.reverse()]
              };
              this.$root.$emit('messages', this.messages);
              this.loadAllUnreadMessages();
            }
            // When user scrolls "UP" or "DOWN"
            else if (data.length > 0) {
              if (this.getScrollDirection === 'UP') {
                this.messages.listOfReadMessages.push(...data.reverse());
              } else {
                if(!(data.length === 1 && data[0].messageBody === this.messages.listOfReadMessages[0].messageBody && data[0].createdAt === this.messages.listOfReadMessages[0].createdAt && data[0].senderGuid === this.messages.listOfReadMessages[0].senderGuid)) {
                  this.messages.listOfUnreadMessages.unshift(...data.reverse());
                }
              }
              this.$root.$emit('messages', this.messages);
            }
            // When someone sends us a message, or when current user sends message
            else if (data.senderGuid) {
              let temp = this.conversationsList.find(item => item.conversationGuid === this.currentConversation.conversationGuid);
              if (!(temp.unreadMessageCount > 0)) {
                if (data.senderGuid === this.coparentGuid || data.senderGuid === this.currentConversation.participantGuid) {
                  this.messages.listOfReadMessages.unshift(...this.messages.listOfUnreadMessages);
                  this.messages.listOfReadMessages.unshift(data);
                  this.messages.listOfUnreadMessages = [];
                  if (this.$refs.conversation) {
                    this.loadAllUnreadMessages();
                  }
                  this.$root.$emit('messages', this.messages);
                }
              }
            }
          });
          this.rerenderConversation++;
          this.renderConversation = true;
        }
      },
      // This method updates array in store, when we keep conversation's guid and whether it is subscribed to messages channel
      makeConversationSubscribed(conversation) {
        let conversations =  this.subscribedConversationsList;
        conversations.forEach(item => {
          if (item.conversationGuid === conversation.conversationGuid) {
            item.subscribed = true
          }
        })

        this.setSubscribedConversationsListAction(conversations);
      },
      // Here, first conversation's guid is sent to channel, to load initial messages
      loadCurrentConversation() {
        if (this.conversationGuidParam !== undefined) {
          let currentConversationTemp = this.conversationsList.find(item => item.conversationGuid === this.conversationGuidParam);
          this.currentConversation = currentConversationTemp === undefined ? {} : currentConversationTemp;
        } else {
          this.currentConversation = this.conversationsList[0] === undefined ? {} : this.conversationsList[0];
        }

        this.loadInitialMessages();
      },
      loadInitialMessages() {
        if (this.currentConversation.conversationGuid !== null && this.currentConversation.fullName !== undefined) {
          if (this.$parent.stompClient && this.$parent.stompClient.connected) {
            this.$parent.stompClient.send(WS_INITIAL_MESSAGES_SEND.replace(':coparentGuid', this.coparentGuid).replace(':participantGuid', this.currentConversation.participantGuid));
          }

          this.$root.$emit('messages', this.messages);
          this.rerenderConversation++;
          this.renderConversation = true;
        }
      },
      // Here, selected coparent's guid is sent to channel, to load it's initial messages
      loadConversation(person) {
        this.currentConversation = person;
        if (this.currentConversation.unreadMessageCount <= 10) {
          this.currentConversation.unreadMessageCount = 0;
        }
        if (this.$parent.stompClient && this.$parent.stompClient.connected) {
          this.$parent.stompClient.send(WS_INITIAL_MESSAGES_SEND.replace(':coparentGuid', this.coparentGuid).replace(':participantGuid', person.participantGuid));
        }
      },
      // Sending coparent's guid to create conversation, if it's not created
      createConversation(person) {
        this.messages.listOfReadMessages = [];
        this.messages.listOfUnreadMessages = [];
        this.$root.$emit('messages', this.messages);
        if (this.$parent.stompClient && this.$parent.stompClient.connected) {
          this.$parent.stompClient.send(WS_CREATE_CONVERSATION_SEND.replace(':coparentGuid', this.coparentGuid).replace(':participantGuid', person.participantGuid));
        }
      },
      // Loading subsequent messages on scroll
      loadSubsequentMessages(messageTimestamp, scrollDirection) {
        if (this.$parent.stompClient && this.$parent.stompClient.connected) {
          this.$parent.stompClient.send(WS_SUBSEQUENT_SEND.replace(':coparentGuid', this.coparentGuid).replace(':participantGuid', this.currentConversation.participantGuid),
            JSON.stringify({
              'messageTimestamp': messageTimestamp,
              'direction': scrollDirection
            }));
        }
      },
      // Loading all unread messages
      loadAllUnreadMessages() {
        if (this.$parent.stompClient && this.$parent.stompClient.connected) {
          this.$parent.stompClient.send(WS_ALL_UNREAD_SEND.replace(':coparentGuid', this.coparentGuid).replace(':participantGuid', this.currentConversation.participantGuid));
        }
      },
      // Sending new message
      sendMessage(message) {
        if (this.$parent.stompClient && this.$parent.stompClient.connected) {
          this.$parent.stompClient.send(WS_SEND_MESSAGE_SEND + this.currentConversation.conversationGuid, JSON.stringify({
            'messageBody': message,
            'receiverGuid': this.currentConversation.participantGuid
          }));
        }
      },
      detectMobile() {
        return (function(a) {
          return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
        })(navigator.userAgent || navigator.vendor || window.opera);
      },
    }
  };
</script>
